module.exports = __webpack_public_path__ + "img/trash-truck-icon.b053b611.svg";